var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames", "../../UI/TitlesElement/TitlesElement"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"), require("../../UI/TitlesElement/TitlesElement"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.TitlesElement);
    global.TeaserVideo = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames, _TitlesElement) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _TitlesElement = _interopRequireDefault(_TitlesElement);

  var TeaserVideo = function TeaserVideo(_ref) {
    var className = _ref.className,
        duration = _ref.duration,
        labels = _ref.labels,
        subtitle = _ref.subtitle,
        title = _ref.title,
        url = _ref.url;
    return /*#__PURE__*/_react.default.createElement("article", {
      className: (0, _classnames.default)('next-teaser', className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "next-teaser__video"
    }, /*#__PURE__*/_react.default.createElement("iframe", {
      className: "next-teaser__iframe",
      src: url,
      allowFullScreen: true,
      frameBorder: "0",
      scrolling: "no",
      title: title,
      width: "100%",
      height: "100%"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "next-teaser__caption"
    }, /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
      title: title,
      subtitle: subtitle
    }), duration > 0 && /*#__PURE__*/_react.default.createElement("p", {
      className: "next-teaser__duration"
    }, "".concat(duration, " ").concat(labels.durationUnit))));
  };

  TeaserVideo.propTypes = {
    className: _propTypes.default.string,
    duration: _propTypes.default.number,
    labels: _propTypes.default.shape({
      durationUnit: _propTypes.default.string
    }),
    subtitle: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired
  };
  TeaserVideo.defaultProps = {
    className: 'next-teaser-video',
    labels: {
      durationUnit: 'min'
    },
    subtitle: ''
  };
  var _default = TeaserVideo;
  _exports.default = _default;
});